/**
 * Upload Configuration
 *
 * Centralized configuration for image upload and processing settings.
 */

export const UPLOAD_CONFIG = {
  // Image dimension constraints
  MAX_DIMENSION: 640, // Maximum width or height in pixels (proportional resizing)

  // File size limits
  MAX_FILE_SIZE_MB: 10,

  // Accepted file types
  ACCEPTED_FORMATS: {
    'image/jpeg': ['.jpeg', '.jpg'],
    'image/png': ['.png'],
    'image/webp': ['.webp']
  },

  // Image quality settings (for JPEG compression after resize)
  RESIZE_QUALITY: 0.9, // 0.9 = high quality, good balance between quality and file size

  // Output format (defaults to original format, or 'image/jpeg' for fallback)
  OUTPUT_FORMAT: 'original' // Can be 'original', 'image/jpeg', 'image/png', 'image/webp'
};
